// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 179) return "plugin.css";
	// return url for filenames based on template
	return "" + chunkId + "." + {"45":"ecf13491764db19abe1d","90":"03ce8272c5f12fb9596f","219":"43c9b63c05c59a28dcb8","378":"dc597d54ba8b0ddba5bd","494":"4cadfc34399b2c06f51a"}[chunkId] + ".chunk.css";
};